export interface DataCore {
    aplicaciones: aplicacion[]; // Aplicaciones disponibles
    grados: grado[];    // Grados disponibles
    asignaturas: asignaturas[]; // Asignaturas disponibles
    temas: { [idAsignatura: number]: string[] }; // Temas por asignatura
}

export interface asignaturas {
    g: number;// id Grado
    i: number;// id Asignatura
    n: string;// Etiqueta de la asignatura
    class: string;// Clase CSS para la asignatura
}

export interface grado {
    i: number;// id Grado
    n: string;// Etiqueta del grado
    class: string;// Clase CSS para el grado

}

export interface aplicacion {
    g: number | null;                // id Grado
    a: number | null;                // id Asignatura
    i: number;                // id Aplicación
    ogrado?: number | null;   // id Otro grado (puede ser null)
    oasignatura?: number | null; // id Otra asignatura (puede ser null)
    obloque?: number | null;  // id Otro bloque (puede ser null)
    oleccion?: number | null; // id Otra lección (puede ser null)
    orden?: number | null;    // Orden (puede ser null)
    p: string;                // Prefijo
    n: string;                // Nombre de la aplicación
    c?: string | null;        // Categoría (puede ser null)
    pc?: string | null;       // Palabras clave (puede ser null)
    o?: string | null;        // Objetivos (puede ser null)
    cg?: string | null;       // Categoría general (puede ser null)
}

export interface aplicacionItem {
    listId: number[]; // Lista de IDs de aplicaciones relacionadas
    g: number;         // id Grado
    a: number;         // id Asignatura
    grado?: grado; // Objeto Grado relacionado
    asignatura?: asignaturas; // Objeto Asignatura relacionado
    action: () => void;
}


export interface GradoItem {
    id?: number; // Id del grado que se recupera de DataCore.grados.
    label?: string;
    action?: () => void;
    clase?: string;
    title?: string; // Título opcional para tooltip o similar
}




export interface AsignaturaItem {
    label: string;// Nombre de la asignatura
    icon: any; // Icono de la asignatura
    action?: () => void;
    clase: string;// Clase CSS para la asignatura
    listID: number[]; // Lista de IDs de asignaturas relacionadas
    listGrados: number[]; // Lista de IDs de grados relacionados
}

export interface temaItem {
    label: string;// Nombre del tema
    id: string; // ID del tema
    action?: () => void;
}

export interface categoriaItem {
    label: string; // Nombre de la categoría
    icon: any; // Icono opcional para la categoría
}

export interface filterData {
    grado: number | null; // id del grado seleccionado; atributo "g" en la interfaz aplicacion
    class_asignatura: string | null; // clase de la asignatura seleccionada; no considerar para el filtro de aplicaciones
    asignatura: number | null; // id de la asignatura seleccionada; atributo "a" en la interfaz aplicacion
    aplicacion: number[] | null; // id de la aplicación seleccionada; atributo "i" en la interfaz aplicacion
    tema: string | null; // nombre del tema seleccionado; tomar el atributo "pc" en la interfaz de aplicacion en donde se debe buscar el valor en ese atributo
    texto: string | null; // texto de búsqueda, tomar los atributos "n", "o", "pc" de la interfaz aplicacion puede aparecer una coincidenca parcial
    categoria: string[]; // categoría de la búsqueda; atributo "cg" en la interfaz de aplicacion coincidencia exacta
}



export const defaultFilterData: filterData = {
    grado: null,
    class_asignatura: null, // clase de la asignatura seleccionada
    asignatura: null,
    aplicacion: null,
    tema: null,
    texto: null,
    categoria: []
};


export interface MenuItem {
    title: string;
    submenu?: SubMenuItem[];
    action: () => void;
    portal: string[];
}

export interface SubMenuItem {
    icon?: any;
    title: string;
    action: () => void;
    portal: string[];
}


export interface GruposLinks {

    id: number,
    label: string,
    items: LinkItems[],
    urlBase?: string
}

export interface LinkItems {

    id: number,
    label: string,
    url: string
}

export interface RecientesApp {
    id: number; // ID de la aplicación reciente
    label: string; // Nombre de la aplicación
    objetivos: string; // Objetivos de la aplicación
    prefijo: string; // Prefijo de la aplicación
    categoria: string; // Categoría de la aplicación
}

export interface responseDataCurso {
    curso : DataCore;
    conoce : RecientesApp[];
    recientes: RecientesApp[];
}
